import { fromJS } from 'immutable';

import { LOAD_ARTICLES_LIST_SUCCESS, TOGGLE_ARTICLE_BAR, UPDATE_ARTICLE_SUCCESS } from 'constants/ActionTypes';

const initialState = fromJS({
  articleBar: false,
  dataset: [],
  pagination: {
    totalCount: null,
    pageCount: null,
    currentPage: null,
    perPage: null,
  },
});

const articleListReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_ARTICLE_SUCCESS:
      return state.set('dataset', state.get('dataset').unshift(action.article.articleId));
    case LOAD_ARTICLES_LIST_SUCCESS:
      return state.merge(
        fromJS({
          dataset: action.articles.items.map((article) => article.articleId),
          pagination: {
            totalCount: action.articles._meta.totalCount,
            pageCount: action.articles._meta.pageCount,
            currentPage: action.articles._meta.currentPage,
            perPage: action.articles._meta.perPage,
          },
        }),
      );
    case TOGGLE_ARTICLE_BAR:
      return state.set('articleBar', !state.get('articleBar'));
    default:
      return state;
  }
};

export default articleListReducer;
